'use client';

import { c as _c } from "react/compiler-runtime";
import { BaseButton } from '@7f-ui/components/button/button';
import { WarningOctagon } from '@phosphor-icons/react';
export type BookingQueryError = {
  priceFailed: boolean;
  availabilityFailed: boolean;
  isRetrying: boolean;
  onRetry: () => void;
};
export const BOOKING_PRICE_ERROR = 'Preise konnten gerade nicht geladen werden.';
export const BOOKING_AVAILABILITY_ERROR = 'Die Verfügbarkeit konnte gerade nicht geladen werden.';
export function AppBookingQueryError(t0) {
  const $ = _c(13);
  const {
    error,
    availabilityMessageInField: t1
  } = t0;
  const availabilityMessageInField = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== error.priceFailed) {
    t2 = error.priceFailed && <p role="alert" className="flex items-start gap-2"><WarningOctagon weight="bold" className="size-5 shrink-0" aria-hidden={true} />{BOOKING_PRICE_ERROR}</p>;
    $[0] = error.priceFailed;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== availabilityMessageInField || $[3] !== error.availabilityFailed) {
    t3 = error.availabilityFailed && !availabilityMessageInField && <p role="alert" className="flex items-start gap-2"><WarningOctagon weight="bold" className="size-5 shrink-0" aria-hidden={true} />{BOOKING_AVAILABILITY_ERROR}</p>;
    $[2] = availabilityMessageInField;
    $[3] = error.availabilityFailed;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = error.isRetrying ? "Wird geladen \u2026" : "Erneut versuchen";
  let t5;
  if ($[5] !== error.isRetrying || $[6] !== error.onRetry || $[7] !== t4) {
    t5 = <BaseButton className="font-semibold underline underline-offset-2 disabled:opacity-50" onClick={error.onRetry} disabled={error.isRetrying} aria-busy={error.isRetrying}>{t4}</BaseButton>;
    $[5] = error.isRetrying;
    $[6] = error.onRetry;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t5) {
    t6 = <div className="flex flex-col items-start gap-2 font-body-small text-error">{t2}{t3}{t5}</div>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}